import { ButtonManager } from 'managers/ButtonManager'
import { ToggleManager } from 'managers/SettingsManager'
import { signal } from 'services/SignalsService'
import { StoreageService } from 'services/StoreageService'
import { TriggerService } from 'services/TriggerService'

const name = 'SETUP'

async function execute() {
  signal.dispatch('RADIO:ui', false)
  signal.dispatch('RADIO:win', StoreageService.get('win'))
  signal.dispatch('RADIO:loss', StoreageService.get('loss'))
  signal.dispatch('GENERATE:BLUR:TEXTURE')
  ToggleManager.dispatch()
  ButtonManager.init()
  game.models.AutoCountModel.setID(StoreageService.get('auto'))
  game.models.BetModel.setID(game.models.BetModel.getID())

  TriggerService.init()

  signal.dispatch('INCLUDE:INIT')
}

export function getSetupAction() {
  return {
    name,
    execute,
  }
}
